const CurrencyTemplate = (rowData, { field }) => {
  return rowData[field].toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

export default CurrencyTemplate;
